import moment from "moment";
import { Row, Col } from "antd";
import { FaAngleDown } from "react-icons/fa";

const FlightSummaryCollapseTripjack = ({
    flightDetails,
    collapseCard,
    setCollapseCard,
    setAddonsCompHide,
}) => {

    const departureSegment = flightDetails?.tripInfos?.[0];
    const returnSegment = flightDetails?.tripInfos?.[1];

    return (
        <div className="card flights-accordion">
            <div className="card-header">
                <Row className="mb-0">
                    <Col xs={24}>
                        <div className="d-flex justify-content-between align-items-center">
                            <h3 className="fw-bold mb-2">Flights Summary</h3>
                            {/* {!collapseCard && (
                                <FaAngleDown
                                    onClick={() => {
                                        setCollapseCard(true);
                                        setAddonsCompHide(true);
                                    }}
                                />
                            )} */}
                        </div>

                        <div className="text-muted mb-2">
                            <span className="fw-bold">{departureSegment?.daCity}</span> →{" "}
                            <span className="fw-bold">{departureSegment?.aaCity}</span> ·{" "}
                            {moment(departureSegment?.sI?.[0].dt).format("dddd, MMM D")} · {departureSegment?.stops === 0 ? "Non Stop" : `${departureSegment?.stops} Stop`} ·{" "}
                            {moment.duration(departureSegment?.total_duration, "minutes").hours() + " H " +
                                moment.duration(departureSegment?.total_duration, "minutes").minutes() + " M"} ·{" "}
                            {departureSegment?.sI?.[0].fD?.aI?.name}
                        </div>
                        {returnSegment &&
                            <div className="text-muted mb-2">
                                <span className="fw-bold">{returnSegment?.daCity}</span> →{" "}
                                <span className="fw-bold">{returnSegment?.aaCity}</span> ·{" "}
                                {moment(returnSegment?.sI?.[0].dt).format("dddd, MMM D")} · {returnSegment?.stops === 0 ? "Non Stop" : `${returnSegment?.stops} Stop`} ·{" "}
                                {moment.duration(returnSegment?.total_duration, "minutes").hours() + " H " +
                                    moment.duration(returnSegment?.total_duration, "minutes").minutes() + " M"} ·{" "}
                                {returnSegment?.sI?.[0].fD?.aI?.name}
                            </div>
                        }
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default FlightSummaryCollapseTripjack;
